export const getCustomPackageRedirectUrl = () => {
    const url = new URL(window.location.href);

    url.searchParams.append('custom_package', 'true');

    return url.toString();
};
